import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/exchange/close_icon.png';
const _withScopeId = n => (_pushScopeId("data-v-7a2aea26"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "manualPage" };
const _hoisted_2 = { class: "manualBox" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "font-w500 font-36" }, "兑换码验证", -1));
const _hoisted_4 = { class: "codeInput" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = ["disabled", "onClick"];
import { Toast } from 'vant';
import { hostPath } from '@/public/utils/basePath';
import { exchangeClaim, claimInit } from '@/api/exchange';
import { appPort, hiddenAppNavBar } from '@/widget/index';
import Header from '@/components/common/Header.vue';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isApp = ref(appPort());
        const codeVal = ref('');
        const nonceVal = ref('');
        /* 返回 */
        const backFn = () => {
            history.go(-1);
        };
        const getData = () => {
            exchangeClaim({
                code: codeVal.value,
                nonce: nonceVal.value
            }).then((res) => {
                if (res.code === 200) {
                    Toast('兑换码验证成功！');
                    location.href = `${hostPath}/learn/exchange/select/${codeVal.value}`;
                }
            });
        };
        // 获取唯一标识
        const getNonce = () => {
            claimInit().then((res) => {
                if (res.code == 200) {
                    nonceVal.value = res.data.nonce;
                    getData();
                }
            });
        };
        const clearCode = () => {
            codeVal.value = '';
        };
        /* app里隐藏头部 */
        if (isApp.value) {
            hiddenAppNavBar();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header, {
                    onBackFn: backFn,
                    showBack: true,
                    isColor: true,
                    pageTitle: '手工输入'
                }),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("input", {
                            class: "manualInput font-36",
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((codeVal).value = $event)),
                            placeholder: "请输入你的兑换码"
                        }, null, 512), [
                            [_vModelText, codeVal.value]
                        ]),
                        _withDirectives(_createElementVNode("div", {
                            class: "closeImg",
                            onClick: _withModifiers(clearCode, ["stop"])
                        }, _hoisted_7, 8, _hoisted_5), [
                            [_vShow, codeVal.value]
                        ])
                    ]),
                    _createElementVNode("button", {
                        class: _normalizeClass(["confirme font-32 gpnt-w500", { backF60: codeVal.value }]),
                        disabled: !codeVal.value,
                        onClick: _withModifiers(getNonce, ["stop"])
                    }, " 确认 ", 10, _hoisted_8)
                ])
            ]));
        };
    }
});
